module.exports = {"id":"201877","name":"Mats Møller Dæhli","rating":"71","photo":"./data/images/photos/3/201877.png","club":{"name":"FC St. Pauli","logo":"./data/images/clubs/FCSt.Pauli.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MatsMøllerDæhli0.json
// module id = 2889
// module chunks = 0